import { useState, useEffect } from "react";
import { signIn, deleteDestination } from "../apis/firebase";
import { decipher } from "../../../common/crypt";

let user: User | null | undefined;
let listeners: Function[] = [];
const now = () => new Date().getTime();

export async function getCaptcha() {
  const res = await fetch(`/api/c`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const captcha = await res.json();
  captcha.text = decipher("contempas")(captcha.text);
  return captcha;
}

export function getUser(): User | null | undefined {
  const [u, setU] = useState<User | null>(user);
  const [_, setChecksum] = useState(now());

  useEffect(() => {
    if (!u) {
      signIn((userData) => {
        user = userData;
        setU(userData);
      });
    }
    const onChange = () => setChecksum(now());
    listeners.push(onChange);
    return () => {
      listeners = listeners.filter((f) => f != onChange);
    };
  }, []);

  return u;
}

export function userUpdated() {
  listeners.forEach((f) => f());
}

export function addUserDestination(d: Destination) {
  if (user) {
    if (!user.destinations) {
      user.destinations = [];
    }
    user.destinations.push(d);
    userUpdated();
  }
}

export async function deleteUserDestination(id: string) {
  if (user) {
    await deleteDestination(id, user);
    user.destinations = user.destinations.filter((d) => d.id !== id);
    userUpdated();
  } else {
    throw new Error("No user available. Please log in.");
  }
}
